import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from 'react-oauth2-code-pkce';
import { Navbar, Footer/*, AlertWebUpdate */, AuthError } from '../components/index.js';

const RootLayout = ({ isOfficer = false }) => {
    const { error } = useContext(AuthContext);
    const location = useLocation();
    const [ isScrollable, setIsScrollable ] = useState(true);
    const [ documentErrorCount, setDocumentErrorCount ] = useState(0);
    // TODO: make more sohpisticated browser check, now it's only checking whether browser is not an Edge
    // let userAgent = navigator.userAgent;
    let pathname = location.pathname;
    const pathMatch = /^\/(zadost|dokumentace)\/([^:?]*$)/.test(pathname);

    return (
        <>
            <Navbar isOfficer={isOfficer} setIsScrollable={setIsScrollable} isScrollable={isScrollable} documentErrorCount={documentErrorCount}/>
            {/*<ErrorWebUpdate error={error} />*/}
            {/* {userAgent.includes('Edg/') ? <AlertWebUpdate /> : ''} */}
            {!error ?
                <div className={isScrollable ? 'home-page-section push-items-down' : 'home-page-section push-items-down disable-scroll'}>
                    {/* {userAgent.includes('Edg/') && <div style={{height: '70px'}}></div>} */}
                    <Outlet context={[documentErrorCount, setDocumentErrorCount]}/>
                </div>
                :
                <AuthError 
                    headerText={'UŽIVATEL NENÍ PŘIHLÁŠEN'}
                    secondaryText={'Přístup na požadovanou stránku nebyl povolen, buď z důvodu vypršení dřívějšího přihlášení nebo odhlášení z portálu. Pro přihlášení do portálu, prosím, klikněte na tlačítko „Přihlásit se“'}
                    errorNumber={'401'}
                />
            }
            {!error && !pathMatch && <Footer isScrollable={isScrollable} />}
        </>
    );
};

RootLayout.propTypes = {
    isOfficer: PropTypes.bool,
};

export default RootLayout;